var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import PerksCard from "../PerksCard";
import { CarouselCard } from "../RewardsCarousel/subcomponents";
import Carousel from "../../../../../ui/molecules/Carousel";
var PerksCarousel = function (_a) {
    var clientId = _a.clientId, perks = _a.perks;
    var t = useTranslation().t;
    return (_jsx(Carousel, __assign({ itemsToShow: perks.length }, { children: perks.map(function (_a) {
            var icon = _a.icon, titleTranslationKey = _a.titleTranslationKey, descriptionTranslationKey = _a.descriptionTranslationKey;
            return (_jsx(CarouselCard, { children: _jsx(PerksCard, { title: t("".concat(clientId, ".perks.").concat(titleTranslationKey)), description: t("".concat(clientId, ".perks.").concat(descriptionTranslationKey)), icon: icon }, titleTranslationKey) }));
        }) })));
};
export default PerksCarousel;
